const dev = {
  API_URL: 'https://api.dev-az.leapxpert.dev',
  CHAT_SERVER: 'https://matrix.dev-az.leapxpert.dev',
  BUILD_NUMBER: __BUILD_NUMBER__,
  VERSION: __VERSION__,
  SENTRY_DSN: 'https://9e0c4cb7e6964aaa83fda4b8d630d838@sentry.io/246882',
  ENCRYPT_DATA: false,
  FIPS_ENABLED: false,
  API_VERSION: 'v1'
}

// eslint-disable-next-line
const qa = {
  API_URL: 'https://api.qa-az.leapxpert.app',
  CHAT_SERVER: 'https://matrix.qa-az.leapxpert.app',
  BUILD_NUMBER: __BUILD_NUMBER__,
  VERSION: __VERSION__,
  SENTRY_DSN: 'https://9e0c4cb7e6964aaa83fda4b8d630d838@sentry.io/246882',
  ENCRYPT_DATA: false,
  FIPS_ENABLED: false,
  API_VERSION: 'v1'
}

const env = window._env_ || dev

export default env